module.exports = __webpack_public_path__ + "static/media/attach.c0a53005.svg";